export const ExternalUserIcon = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="2.75" y="2.75" width="14.5" height="14.5" rx="3.25" stroke="#0047FF" strokeWidth="1.5" />
			<path
				d="M7.4974 9.16699C7.95763 9.16699 8.33073 8.7939 8.33073 8.33366C8.33073 7.87342 7.95763 7.50033 7.4974 7.50033C7.03716 7.50033 6.66406 7.87342 6.66406 8.33366C6.66406 8.7939 7.03716 9.16699 7.4974 9.16699Z"
				fill="#0047FF"
			/>
			<path
				d="M13.3307 8.33366C13.3307 8.7939 12.9576 9.16699 12.4974 9.16699C12.0372 9.16699 11.6641 8.7939 11.6641 8.33366C11.6641 7.87342 12.0372 7.50033 12.4974 7.50033C12.9576 7.50033 13.3307 7.87342 13.3307 8.33366Z"
				fill="#0047FF"
			/>
			<path
				d="M8.14152 11.9716C7.85264 11.6195 7.33347 11.5643 6.97682 11.8496C6.61743 12.1371 6.5602 12.6628 6.84771 13.0222L6.92143 13.1074C6.96076 13.1504 7.01481 13.2065 7.0837 13.271C7.22113 13.3999 7.41986 13.5648 7.68073 13.7278C8.20577 14.056 8.98174 14.3753 9.9974 14.3753C11.0131 14.3753 11.789 14.056 12.3141 13.7278C12.5749 13.5648 12.7737 13.3999 12.9111 13.271C12.98 13.2065 13.034 13.1504 13.0734 13.1074L13.1481 13.0209C13.4356 12.6615 13.3774 12.1371 13.018 11.8496C12.6613 11.5643 12.1422 11.6195 11.8533 11.9716L11.8433 11.9828C11.8306 11.9967 11.8065 12.0221 11.7712 12.0551C11.7003 12.1216 11.5865 12.2171 11.4307 12.3145C11.1224 12.5072 10.6484 12.7087 9.9974 12.7087C9.34639 12.7087 8.87235 12.5072 8.56406 12.3145C8.40827 12.2171 8.2945 12.1216 8.2236 12.0551C8.18831 12.0221 8.16424 11.9967 8.15148 11.9828L8.14152 11.9716Z"
				fill="#0047FF"
			/>
		</svg>
	)
}
